import { ContentContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import Link from 'next/link';

const GlobalLink = (props) => {
  const locale = useContext(LocaleContext);
  const content = useContext(ContentContext);
  return locale === 'en' ? (
    <Link href='/' as='/'>
      <a>{props.children ? props.children : content.common.nav.global}</a>
    </Link>
  ) : (
    <Link href='/[locale]' as={`/${locale}`}>
      <a>{props.children ? props.children : content.common.nav.global}</a>
    </Link>
  );
};

export default GlobalLink;
